import React from 'react';
import { Button } from '../ui/button';
import { Edit2, Save, X } from 'lucide-react';

/**
 * Inline editable name field component
 * Handles name editing with validation
 */
const EditableName = ({ 
  user, 
  isEditing, 
  nameEditText, 
  onNameChange, 
  onNameSave, 
  onNameCancel,
  onNameClick,
  isSaving 
}) => {
  const MAX_NAME_LENGTH = 20;
  const charsLeft = MAX_NAME_LENGTH - nameEditText.length;

  return (
    <div>
      {isEditing ? (
        <div className="space-y-2">
          <div className="flex items-center justify-center gap-2">
            <input
              type="text"
              value={nameEditText}
              onChange={(e) => onNameChange(e.target.value)}
              className="text-2xl font-bold text-center border-b-2 border-purple-500 focus:outline-none bg-transparent"
              maxLength={MAX_NAME_LENGTH}
              autoFocus
            />
            <Button
              size="sm"
              onClick={onNameSave}
              disabled={isSaving}
              className="bg-purple-600 hover:bg-purple-700"
            >
              <Save className="h-4 w-4" />
            </Button>
            <Button
              size="sm"
              variant="outline"
              onClick={onNameCancel}
              disabled={isSaving}
            >
              <X className="h-4 w-4" />
            </Button>
          </div>
          <div className="text-center">
            <span className="text-xs text-gray-500">
              {charsLeft} character{charsLeft !== 1 ? 's' : ''} left
            </span>
          </div>
        </div>
      ) : (
        <div className="flex items-center justify-center gap-2">
          <h1 className="text-2xl font-bold">{user.name}</h1>
          <Button
            size="sm"
            variant="ghost"
            onClick={onNameClick}
            className="text-gray-400 hover:text-purple-600"
          >
            <Edit2 className="h-4 w-4" />
          </Button>
        </div>
      )}
    </div>
  );
};

export default EditableName;
